import * as React from 'react';
import ListMonthContainer from '../components/list/container';
import { CalendarContainerProps } from '../components/buytickets-container';
import LoaderView from '../components/loader';

const CalendarContainerView: React.StatelessComponent<CalendarContainerProps> = props => {
    return (
        <>
            <LoaderView /> 
            <ListMonthContainer />
        </>
    )
}

export default CalendarContainerView;